import React, { useState, useEffect } from 'react'
import CartIcon from './CartIcon'
import { useCartState } from '@/contexts/CartContext'
import { motion, AnimatePresence } from 'framer-motion'
import CartModal from './CartModal'
import { useRouter } from 'next/router'

type Props = {}

const FloatingCartButton = (props: Props) => {
  const cart = useCartState()
  const cartItemsCount = cart.items.length
  const [isCartModalOpen, setIsCartModalOpen] = useState(false)
  const router = useRouter()

  // Close cart modal when URL changes
  useEffect(() => {
    setIsCartModalOpen(false)
  }, [router.asPath])

  // Animation variants
  const variants = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
        // Nudge effect after appearing
        x: {
          repeat: 1,
          repeatType: 'mirror',
          duration: 0.1,
          delay: 0.2,
          keyframes: [0, -6, 6, -2, 2, 0]
        }
      }
    },
    exit: { x: -100, opacity: 0, transition: { duration: 0.2 } }
  }

  return (
    <>
    <AnimatePresence>
        {cartItemsCount > 0 && (
          <motion.div
          className="fixed bottom-0 left-0 m-4 z-50 md:hidden"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
        >
          <div className="bg-primary rounded-3xl shadow-lg px-5 py-3 flex items-center gap-2 relative" onClick={() => setIsCartModalOpen(true)}>
            <p className="bg-emerald-400 text-primary w-[18px] h-[18px] p-2 flex items-center justify-center text-sm font-semibold text-center rounded-full absolute  right-[6px] top-[5px] z-10">
              <span>{cartItemsCount}</span>
            </p>
            <CartIcon color="#fff" />
            <p className="text-base text-white" >عرض السلة</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
    <CartModal isOpen={isCartModalOpen} onClose={() => setIsCartModalOpen(false)} />
    </>
  )
}

export default FloatingCartButton
